/**
 * Date formatting for calendar pickers (portal-style)
 */

export const formatDate = (dateString?: string | null): string => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateString;
  }
};

export const formatDateRange = (startDate?: string | null, endDate?: string | null): string => {
  if (!startDate || !endDate) return 'Select date range';
  try {
    const start = new Date(startDate + 'T12:00:00');
    const end = new Date(endDate + 'T12:00:00');
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return 'Select date range';
    const fmt = (d: Date) =>
      d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    return `${fmt(start)} — ${fmt(end)}`;
  } catch {
    return 'Select date range';
  }
};

export const formatDateShort = (dateString?: string | null): string => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString + 'T12:00:00');
    if (isNaN(date.getTime())) return dateString;
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const y = date.getFullYear();
    return `${m}/${d}/${y}`;
  } catch {
    return dateString;
  }
};
